import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
  })
  export class CommonFunction {
    constructor(public _snackBar: MatSnackBar,public router:Router) { }

     async errorToast(msg,timout:boolean,url) {
        await this._snackBar.open(msg,
          "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
        if(timout){
            setTimeout(() => {
                this.router.navigate([url])
                // this.gotoList()
              }, 2000);
        }
      }

      async successToast(msg,timeout,url) {
        await this._snackBar.open(
          msg,
          "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "success-toast",
          duration: 3 * 1000,
        });
        if(timeout){
            setTimeout(() => {
                this.router.navigate([url])
              }, 2000);
        }
      }

getLevels(){
  return [
    { 'value': 1 },
    { 'value': 2 },
    { 'value': 3 },
  ];
}

getEscalationDays(){
 return [
    { 'value': "1" },
    { 'value': "2" },
    { 'value': "3" },
    { 'value': "4" },
    { 'value': "5" },
    { 'value': "6" },
    { 'value': "7" },
    { 'value': "8" },
    { 'value': "9" },
    { 'value': "10" },
  ]
}
      
  }